export default {"src":"/_next/static/media/Dorara.0191b558.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};